import React, { useEffect } from "react";
import { Routes, Route, useLocation, useNavigationType } from "react-router-dom";
import { Layout } from "antd";
import { useDynamicSeo } from "./hooks/useDynamicSeo";
import AppHeader from "./Components/AppHeader";
import AppSlider from "./Components/AppSlider";
import AppContent from "./Components/AppContent";
import AppFooter from "./Components/AppFooter";
import AsanaDetails from "./Components/main/AsanaDetails";

import Yoga from "./Components/Header/Yoga";
import Breathe from "./Components/Header/Breathe";
import Time from "./Components/Header/Time";
import Alternateasana from "./Components/Header/Alternateasana";
import Chakra from "./Components/Header/Chakra";
import Tool from "./Components/Header/Tool";

import Meditation from "./Components/Header/Meditation";
import DosAndDonts from "./Components/Header/DosAndDonts";
import Shatkarmas from "./Components/Header/Shatkarmas";
import PrivacyPolicy from "./Components/Header/PrivacyPolicy";
import TermsConditions from './Components/Header/TermsConditions';
import Warmup from "./Components/Header/WarmUp";
import Mudra from "./Components/Header/Mudra";
import HowToMakeVariation from "./Pages/HowToMakeVariation";

import DictionaryPage from "./Components/Header/DictionaryPage";

const { Content } = Layout;

// A new page should open at its top, not at the scroll position of the page
// before it. Back/forward is left alone so the browser can restore its place.
const useScrollToTopOnNavigate = () => {
  const { pathname } = useLocation();
  const navigationType = useNavigationType();

  useEffect(() => {
    if (navigationType !== "POP") window.scrollTo(0, 0);
  }, [pathname, navigationType]);
};

const App = () => {
  useDynamicSeo();
  useScrollToTopOnNavigate();
  return (
    <Layout style={{ minHeight: "100vh" }}>
      <AppHeader />

      <Layout style={{ marginTop: 40 }}>
        <AppSlider />

        <Content
          className="overall"
          style={{ padding: 16, background: "#fff" }}
        >
          <Routes>
            <Route path="/" element={<AppContent />} />
            <Route path="/asanas/:slug" element={<AsanaDetails />} />
            {/* <Route path="/how-to-make-variation" element={<Makevariation />} /> */}
            <Route path="/yoga/:slug?" element={<Yoga />} />
            <Route path="/alternate-asana" element={<Alternateasana />} />
            <Route
              path="/how-to-make-variation/:category?/:pose?"
              element={<HowToMakeVariation />}
            />
            <Route path="/warm-up/:slug?" element={<Warmup />} />
            <Route path="/breathe-technique/:slug?" element={<Breathe />} />
            <Route path="/meditation/:slug?" element={<Meditation />} />
            <Route path="/chakra/:slug?" element={<Chakra />} />
            <Route path="/dos-and-donts" element={<DosAndDonts />} />
            <Route path="/mudra/:slug?" element={<Mudra />} />
            <Route path="/shatkarmas/:slug?" element={<Shatkarmas />} />
            <Route path="/tool/:slug?" element={<Tool />} />
            <Route path="/time" element={<Time />} />
            <Route path="/dictionary/:langSlug?" element={<DictionaryPage />} />
            {/* <Route path="/dummy-technique" element={<DummyBreathe />} /> */}
            {/* <Route path="/dummytool" element={<DummyTool />} /> */}
            {/* <Route path="/dummyMeditation" element={<DummyMeditation />} /> */}
            {/* <Route path="/demo-yoga" element={<DemoYoga />} /> */}
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-conditions" element={<TermsConditions />} />
          </Routes>

          <AppFooter />
        </Content>
      </Layout>
    </Layout>
  );
};

export default App;
